
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"menu-action.title":"Drill-through ausführen","drillThrough.other.category":"Weitere Drill-throughs"},"en":{"menu-action.title":"Execute drill-through","drillThrough.other.category":"Further drill-throughs"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();